import {useWebView} from '@/common-pages/hooks/webview.hooks';
import theme from '@/style';
import React, {useEffect, useRef, useState} from 'react';
import {View} from 'react-native';
import {envConfig, getUrlParams, goTo, hideTabbar, showTabbar} from '@/utils';
import globalStore from '@/services/global.state';
import {homePage} from '@/config';
import {BasicObject} from '@/types';
import {getGR8Token} from '@/pages/home/home.service';
import {mainPageList, TabBarList} from '@/main-navigation';
import {useDebounce} from 'ahooks';
import qs from 'qs';
import SportSpin from '@/components/basic/sportspin/sportspin';
const Gr8 = ({
  singleAppPage,
  onAuthFailed,
}: {
  singleAppPage?: boolean;
  onAuthFailed: () => void;
}) => {
  const [pageLoading, setPageLoading] = React.useState(true);
  const [fullDataPathResult, setFullDataPathResult] = useState<any>();
  const handleMessage = (data: string | BasicObject) => {
    if (typeof data === 'object') {
      if ((data as any).type === 'login.click') {
        goTo('Login', {
          backPage: homePage,
          sucessPage: homePage,
        });
        return;
      }
      if ((data as any).type === 'auth.fail') {
        if (window.location.pathname.includes('/index/sports')) {
          goTo('Login', {
            backPage: homePage,
            sucessPage: homePage,
          });
          return;
        }
        onAuthFailed();
      }
      if ((data as any).type === 'user.balance') {
        globalStore.updateAmount.next({});
        return;
      }
      if ((data as any).type === 'navigation') {
        setFullDataPathResult(data);
      }
    }
  };
  const firstEventsPath = useRef<string>();
  const nowRoutePath = useRef<string>();
  const [version, setVersion] = useState(0);
  const [token, setToken] = useState<string>();
  const debouncedToken = useDebounce(token, {wait: 500});
  const prefixDebouncedToken = useRef<string>();
  const [sportToken, setSportToken] = useState<string>();
  const lastSportToken = useRef<string>();
  const [lang, setLang] = useState<string>();
  useEffect(() => {
    if (!fullDataPathResult) {
      return;
    }
    setTimeout(() => {
      const langPrefix = lang?.split('_')[0].toLowerCase() || 'en';
      const dataPath = fullDataPathResult?.path.replace(
        new RegExp(`/${langPrefix === 'en' ? 'en' : `(en|${langPrefix})`}`),
        '',
      );
      if (window.location.pathname.includes('/index/sports')) {
        const newQuery = {...fullDataPathResult.query};
        delete newQuery.jwt;
        const queryStr = qs.stringify(newQuery).trim();
        if (
          dataPath.trim() === '/' ||
          dataPath.trim() === '' ||
          dataPath.trim() === '/favorites'
        ) {
          showTabbar(true);
        } else {
          // 只能使用display: none来隐藏，否则会出现点击下注时顶出tabbar的高度问题
          hideTabbar(true);
        }
        window.history.replaceState(
          null,
          '',
          `${window.location.origin}/index/sports?path=${encodeURIComponent(
            `${dataPath}${queryStr ? `?${queryStr}` : ''}`,
          )}`,
        );
      } else {
        const [path, query] = nowRoutePath.current?.split('?') || [];
        if (
          path === dataPath ||
          dataPath.trim() === '/' ||
          dataPath.trim() === ''
        ) {
          return;
        }
        const json = qs.parse(query || '');
        const _sportToken = sportToken === 'none' ? undefined : sportToken;
        json.jwt = _sportToken;
        const queryStr = qs.stringify(json);
        const url = `${envConfig.gr8IframeUrl}${langPrefix}${path || '/'}${
          queryStr ? `?${queryStr}` : ''
        }`;
        updateUrl?.(url);
      }
    }, 10);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullDataPathResult, lang, sportToken]);
  useEffect(() => {
    const urlParams = getUrlParams();
    if (!urlParams.path || urlParams.path.trim() === '/') {
      return;
    }
    if (
      urlParams.path.includes('/events') ||
      urlParams.path.includes('/promo')
    ) {
      firstEventsPath.current = urlParams.path;
    } else {
      nowRoutePath.current = urlParams.path;
      setVersion(v => v + 1);
    }
  }, []);
  useEffect(() => {
    if (sportToken == null) {
      return;
    }
    const _sportToken = sportToken === 'none' ? undefined : sportToken;
    if (lastSportToken.current && lastSportToken.current !== sportToken) {
      postMessage?.({
        type: 'iframe',
        value: {logout: true},
      });
    }
    lastSportToken.current = _sportToken;
    setTimeout(() => {
      const [path, query] = nowRoutePath.current?.split('?') || [];
      const json = qs.parse(query || '');
      json.jwt = _sportToken;
      const queryStr = qs.stringify(json);
      const url = `${envConfig.gr8IframeUrl}${
        lang?.split('_')[0].toLowerCase() || 'en'
      }${path || '/'}${queryStr ? `?${queryStr}` : ''}`;
      updateUrl?.(url);

      setTimeout(() => {
        if (firstEventsPath.current) {
          nowRoutePath.current = firstEventsPath.current;
          firstEventsPath.current = undefined;
          setVersion(v => v + 1);
        }
      }, 1000);
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sportToken, version, lang]);

  useEffect(() => {
    if (debouncedToken == null) {
      return;
    }
    if (prefixDebouncedToken.current == null) {
      prefixDebouncedToken.current = debouncedToken;
      return;
    }
    if (prefixDebouncedToken.current !== debouncedToken) {
      prefixDebouncedToken.current = debouncedToken;
      nowRoutePath.current = '/';
    }
  }, [lang, debouncedToken]);

  useEffect(() => {
    if (debouncedToken == null) {
      return;
    }
    const _token = debouncedToken === 'none' ? undefined : debouncedToken;

    if (_token) {
      getGR8Token().then(res => {
        setSportToken(res.token);
      });
    } else {
      setSportToken('none');
    }
  }, [debouncedToken]);

  const {postMessage, updateUrl, render} = useWebView({
    originUrl: ' ',
    onMessage: handleMessage,
    onLoadEnd: () => {
      setTimeout(() => {
        setPageLoading(false);
      }, 500);
    },
  });

  useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(_token => {
      setToken(_token || 'none');
    });
    const langSub = globalStore.langSubject.subscribe(_lang => {
      setLang(_lang);
    });
    const sportSub = globalStore.openSports.subscribe(_path => {
      if (_path != null) {
        nowRoutePath.current = _path;
        setVersion(v => v + 1);
      }
    });
    return () => {
      sub.unsubscribe();
      sportSub.unsubscribe();
      langSub.unsubscribe();
    };
  }, []);

  return singleAppPage ? (
    <View
      style={[
        theme.fill.fill,
        theme.flex.col,
        theme.position.abs,
        theme.background.lightGrey,
        {display: 'none', top: 0, left: 0, right: 0, bottom: 0},
      ]}
      id="gr8">
      <SportSpin loading={pageLoading}>{render}</SportSpin>
      <TabBarList
        list={mainPageList.map(item => ({name: item.name}))}
        activeIndex={1}
      />
    </View>
  ) : (
    <View
      style={[theme.fill.fill, theme.flex.col, theme.background.lightGrey]}
      id="gr8">
      <SportSpin loading={pageLoading}>{render}</SportSpin>
    </View>
  );
};

export default Gr8;
